import { Star } from "lucide-react";

export const StarRating = ({ rating, size = 16, showValue = true }) => {
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= rating ? "fill-amber-500 text-amber-500 star-glow" : "text-zinc-600"}
        />
      ))}
      {showValue && <span className="ml-1 text-sm text-zinc-400">{rating.toFixed(1)}</span>}
    </div>
  );
};

export default StarRating;
